module.exports = __webpack_public_path__ + "static/media/599.7554(16).da985b3d.pdf";